import { render } from "./ErrorArea.vue?vue&type=template&id=321d2742&scoped=true"
import script from "./ErrorArea.vue?vue&type=script&lang=js"
export * from "./ErrorArea.vue?vue&type=script&lang=js"

import "./ErrorArea.vue?vue&type=style&index=0&id=321d2742&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321d2742"]])

export default __exports__